/*
 *
 * ExtendSessionModal
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 24-Sep-2025
*/

import ExtendSessionModal from './ExtendSessionModalContainer'

export default ExtendSessionModal
